module.exports = "/_next/static/images/Hyatt-Logo-08f271d45abcad077f20a5b421aa715f.png";